module.exports = __webpack_public_path__ + "img/grb_60x120-2.25acc9ba.png";